angular.module('picmonicng').factory('WorkflowTasksResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/workflows/:workflow_id/states/:workflow_state_id/tasks/:workflow_task_id',
      {
        workflow_id: '@workflow_id',
        workflow_state_id: '@workflow_state_id',
        workflow_task_id: '@workflow_task_id',
      },
      {
        update: { method: 'PUT' },
      }
    );
  },
]);
